export const frontmatter = {
    "draft": false,
    "title": "Base de conocimiento",
    "description": "Bases de conocimiento y RAG en OnnIA.",
    "sidebar_label": "Descripción general",
    "sidebar_group": "referencia",
    "sidebar_order": 1
}

export const toc = []